module.exports = __webpack_public_path__ + "static/home-7c1016f124b606a1e7796a4b84b633a6.png";